/**
 * Layout
 */

import {
	debounce,
	getRootVar,
	setRootVar
} from '../../shared/utils';

import SelectorEngine from '../../shared/dom/selector-engine';
import Manipulator from '../../shared/dom/manipulator';

import header from './header';
import menu from './menu';
import footer from './footer';
import search from './search';

import Jumplist from '../../shared/components/jumplist';
import {scrollElementIntoView} from "../../shared/utils/scroll";

/**
 * Sprungliste die einer Seite ´global´ hinzugefügt wurde.
 */
const pageJumplist = () => {
	const originalDocTitle = document.title;
	const originalDocUrl   = location.href;
	const pageJumplist     = SelectorEngine.findOne('#page-jumplist');
	const scrollTopOffset = parseInt(getRootVar('global-scroll-top-offset') || 0, 10);

	if (pageJumplist) {
		const calcRootMargin = () => {
			return `0px 0px -${scrollTopOffset}px 0px`;
		};

		const scrollToCurrentItem = (event) => {
			return `0px 0px -${scrollTopOffset}px 0px`;
		};

		const apiPageJumplist = Jumplist.init(pageJumplist, {
			windowMode: true, // Diese Jumplist ´behandelt´ das Window-Objekt!
			rootMargin     : calcRootMargin(),
			onNavigate: (event) => {
				//
				// ´Scroll top offset´ dem Zielbereich zuweisen.
				// Somit verschwindet er nicht visuell unter der Jumplist.
				//

				const sto = parseInt(getRootVar('global-scroll-top-offset') || 0, 10);
				const jlh = pageJumplist.offsetHeight;

				event.section.style.scrollMarginTop = `${jlh + sto}px`;

				//
				// Dokumenetentitel, -URL und Historieaktualisieren.
				//

				const newDocTitle = `${originalDocTitle} (${event.link.jumplistText})`;
				const historyUrl  = location.hash ? `${originalDocUrl.split('#')[0]}${event.link.jumplistHash}` : `${location.href.split('#')[0]}${event.link.jumplistHash}`;

				// Seitentitel aktualisieren.
				document.title = newDocTitle;

				// History aktualsieren.
				history.pushState({
					section: event.section.jumplistHash,
					title  : newDocTitle
				}, '', historyUrl);

				debounce(() => {
					scrollToCurrentItem(event);
				}, 300);
			},
			onActivate: (event) => {
				scrollElementIntoView(
					event.link,
					SelectorEngine.findOne('.jumplist__container', event.target),
					'horizontal'
				);
			}
		});

		if (location.hash) {
			apiPageJumplist.activate(location.hash);
		}

		window.addEventListener('resize', debounce(() => {
			apiPageJumplist.setOptions({
				rootMargin: calcRootMargin()
			});
			apiPageJumplist.refresh();
		}, 200));
	}
};

/**
 * Einige globale Layoutdimensionen bestimmen und per CSS-Rootvariable verfügbar machen.
 */
const scaffoldingCalcDimensions = () => {
	const container = Manipulator.elementAppend(`<div class="scd" style="height:2px;inset:0 0 auto 0;opacity:0;padding-inline:var(--${window.pageInstance.prefix}page-margin, 1rem);pointer-events:none;position:absolute;width:100%;z-index:100000;">
		<div class="scd-inner" style="height:1px;margin-inline:auto;max-width:var(--${window.pageInstance.prefix}page-max-width, calc(100% - 2rem));width:100%;">
			<div class="row" style="height:1px;margin-block:0;"><div class="col col-1" style="height:1px;margin-block:0;"></div></div>
		</div>
	</div>`);

	const elGcw = SelectorEngine.findOne('.scd-inner', container);
	const elCw = SelectorEngine.findOne('.col-1', container);

	const calc = () => {
		// Aktuelle Inhaltsbreite bereitstellen.
		setRootVar(`global-content-width`, `${elGcw.offsetWidth}px`);

		// Aktuelle Breiten einer ´Grid column´ bereitstellen.
		const elCwComputed = getComputedStyle(elCw);
		const elCwPaddingLeft = parseInt(elCwComputed.paddingInlineStart, 10) || 0;
		const elCwPaddingRight = parseInt(elCwComputed.paddingInlineEnd, 10) || 0;

		setRootVar(`global-column-width`, `${elCw.offsetWidth}px`);
		setRootVar(`global-column-inner-width`, `${(elCw.offsetWidth - elCwPaddingLeft - elCwPaddingRight)}px`);
	};

	window.addEventListener('resize', calc);
	window.addEventListener('orientationchange', calc);

	calc();
};

// ------
// Public
// ------

const index = () => {
	scaffoldingCalcDimensions();
	header().then(r => {
		// Do nothing
	});
	menu();
	footer();
	search().then(r => {
		// Do nothing
	});

	// Sprungliste (hinzugefügt einer Seite)
	pageJumplist();
};

// Export
export default index;
